import { render, staticRenderFns } from "./ExpiredBaskets.vue?vue&type=template&id=a668b04e&"
import script from "./ExpiredBaskets.vue?vue&type=script&lang=js&"
export * from "./ExpiredBaskets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports